import React, { useEffect, useRef, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import TopMenu from "../../TopMenu";
import { companyId } from "../../../../utils/companyId";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const MobileCombustionDocuments = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("On Road");
  const [url, setUrl] = useState("onroad");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [onRoadFilter, setOnRoadFilter] = useState({ transportType: "" });
  const [offRoadFilter, setOffRoadFilter] = useState({});
  const [columnWidth, setColumnWidth] = useState(
    user?.companyAdmin
      ? "12% 15% 15% 10% 10% 10% 17% 8%"
      : "12% 12% 18% 15% 10% 18% 8%"
  );
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const fetchData = async () => {
    try {
      await fetchFilters();
      let filters = { ...filterObj };
      if (filters.efficiency) {
        filters.minEfficiency = parseInt(filterObj.efficiency.min);
        filters.maxEfficiency = parseInt(filterObj.efficiency.max);
        delete filters.efficiency;
      }

      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: 10,
        company: companyId,
        facilityList: selectedFacility.join(","),
        createdBy: companyId,
        search: searchQuery,
      }).toString();
      const response = await get(
        `/scope1/mobileCombustion/documents/${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const onRoadFetchFilters = async () => {
    const response = await get(`/scope1/mobileCombustion/onRoadFilters`);
    setOnRoadFilter({
      transportType: response?.data?.data?.transportType,
    });
  };

  console.log("onr", onRoadFilter?.transportType);

  useEffect(() => {
    onRoadFetchFilters();
  }, []);

  const fetchFilters = async () => {
    try {
      const res2 = await get(`/scope1/mobileCombustion/documents/offroad`);
      const data2 = res2.data.data;

      setOffRoadFilter({
        machineryCategory: [
          ...new Set(
            data2.map((el) => el.machineryCategory).filter(Boolean) // Filter out undefined values
          ),
        ],
        machineryType: [
          ...new Set(
            data2.map((el) => el.machineryType?.name).filter(Boolean) // Filter out undefined values
          ),
        ],
        fuelType: [
          ...new Set(
            data2.map((el) => el.fuelType).filter(Boolean) // Filter out undefined values
          ),
        ],
      });
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchQuery, filterObj, url, fromDate, toDate, selectedFacility]);

  const onRoadHeading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Vehicle Number",
      key: "vehicleNumber",
    },
    {
      title: "Transport Type",
      key: "transportType",
    },
    {
      title: "Vehicle Efficiency",
      key: "efficiency",
    },
    {
      title: "Fuel Type",
      key: "fuelType",
    },
  ].filter(Boolean);

  const offRoadHeading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Machinery Category",
      key: "machineryCategory",
    },
    {
      title: "Machinery Type",
      key: "machineryType",
    },
    {
      title: "Machinery Name",
      key: "machineryName",
    },
    // {
    //   title: "Fuel Type",
    //   key: "industrialEquipment",
    // },
    // {
    //   title: "Unique ID",
    //   key: "industrialEquipment",
    // },
    {
      title: "Fuel Type",
      key: "fuelType",
    },
  ].filter(Boolean);

  const [headers, setHeaders] = useState(onRoadHeading);

  const offRoadFilters = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Machinery Category",
      type: "option",
      key: "machineryCategory",
      value: offRoadFilter?.machineryCategory,
    },
    {
      title: "Machinery Type",
      type: "option",
      key: "machineryType",
      value: offRoadFilter?.machineryType,
    },
    {
      title: "Fuel Type",
      type: "option",
      key: "fuelType",
      value: offRoadFilter?.fuelType,
    },
  ];

  const onRoadFilters = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Transport Type",
      type: "option",
      key: "transportType",
      value: onRoadFilter?.transportType ? onRoadFilter.transportType : [],
    },
    {
      title: "Vehicle Efficiency",
      type: "limit",
      key: "efficiency",
      value: [],
      min: "min",
      max: "max",
      // value: ["filterDestination"],
    },
  ];

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);
  const [filterData, setFilterData] = useState(onRoadFilters);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
    setSearchQuery("");
    setSelectedMonth(currentMonth + 1);
    setSelectedYear(currentYear);
    setFilterObj({});
    // setColumnWidth(
    //   option === "On Road"
    //     ? "12% 12% 18% 15% 10% 18% 8%"
    //     : "12% 12% 18% 15% 12% 18% 8%"
    // );
    setFilterData(option === "On Road" ? onRoadFilters : offRoadFilters);
    setHeaders(option === "On Road" ? onRoadHeading : offRoadHeading);
  };

  useEffect(() => {
    setSelectedOption("On Road");
    setHeaders(onRoadHeading);
    setFilterData(onRoadFilters);
  }, []);

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setIsFiltersApplied(
      Object.keys(newFilterObj).some(
        (key) =>
          filterObj[key] &&
          (Array.isArray(filterObj[key])
            ? filterObj[key].length > 0
            : filterObj[key])
      )
    );
  };

  const toggleData = [
    { title: "On Road", url: "onroad" },
    { title: "Off Road", url: "offroad" },
  ];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <>
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData,
            searchQuery,
            setSearchQuery,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Mobile Combustion"}
        />

        <TableDocument
          {...{
            data,
            totalPages,
            headers,
            page,
            handleChangePage,
            columnWidth,
            isShortContent,
            tableContainerRef,
          }}
        />

        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={
            url === "onroad"
              ? onRoadFilters
              : url === "offroad"
              ? offRoadFilters
              : {}
          }
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default MobileCombustionDocuments;
